import { administration } from './administration'
import { loginGuard } from '../login_guard'

const index = [
  administration,
  {
    path: '/',
    component: () => import('layouts/RootLayout.vue'),
    meta: {},
    children: [
      {
        path: '',
        component: () => import('pages/AllCollectionsContainer.vue'),
        children: [
          {
            path: '',
            name: 'collection-list',
            component: () => import('pages/AllCollectionsPage.vue')
          },
          {
            path: ':collectionCode',
            component: () => import('pages/restorations/RestorationsListContainer.vue'),
            props: true,
            beforeEnter: loginGuard,
            children: [
              {
                path: '',
                name: 'collection',
                props: true,
                component: () => import('pages/restorations/RestorationsListPage.vue')
              },
              {
                path: 'create',
                name: 'collection-create',
                props: true,
                component: () => import('pages/restorations/RestorationsListPage.vue')
              },
              {
                path: ':itemId',
                component: () => import('pages/restorations/RestorationsContainer.vue'),
                props: true,
                children: [
                  {
                    path: '',
                    component: () => import('pages/restorations/RestorationsPage.vue'),
                    props: true,
                    children: [
                      {
                        name: 'collection-item',
                        path: '',
                        redirect: 'info',
                        props: true
                      },
                      {
                        name: 'restorations-page-basic-info',
                        path: 'info',
                        component: () => import('pages/restorations/detail/BasicInfoPage.vue'),
                        props: true
                      },
                      {
                        name: 'restorations-page-materials',
                        path: 'materials',
                        component: () => import('pages/restorations/detail/MaterialsPage.vue'),
                        props: true
                      },
                      {
                        name: 'restorations-page-works',
                        path: 'works',
                        component: () => import('pages/restorations/detail/WorksPage.vue'),
                        props: true
                      },
                      {
                        name: 'restorations-page-gallery',
                        path: 'gallery',
                        component: () => import('pages/restorations/detail/GalleryPage.vue'),
                        props: true
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
]

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  index.push({
    path: '*',
    component: () => import('pages/Error404.vue')
  })
}

export default index
